<template>
  <div class="trial-framework">
    <section v-if="isShow('primary')" class="level">
      <h2 class="level-branch">小学部</h2>
      <div class="level-grade" v-for="(grade, index) in primary" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, primary, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <section v-if="isShow('middle')" class="level">
      <h2 class="level-branch">中学部</h2>
      <div class="level-grade" v-for="(grade, index) in middle" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, middle, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <section v-if="isShow('high')" class="level">
      <h2 class="level-branch">高中部</h2>
      <div class="level-grade" v-for="(grade, index) in high" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, high, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <section v-if="isShow('secondary')" class="level">
      <h2 class="level-branch">中专部</h2>
      <div class="level-grade" v-for="(grade, index) in secondary" :key="index">
        <span>{{ grade.term_name }}</span>
        <p class="count">
          <span>共有</span>
          <el-input
            type="text"
            size="small"
            v-model.number="grade.class_total"
            @blur="handleBlur(grade.class_total, secondary, index)"
          ></el-input>
          <span>个班</span>
        </p>
      </div>
    </section>

    <div v-if="!showList && showList.length === 0" class="frame-tip" style="font-size: 14px">
      该类型未预设默认架构，申请成功后可进入管理台自行配置
    </div>
  </div>
</template>

<script>
export default {
  name: 'Framework',

  props: {
    type: { type: String, default: '' }
  },

  data() {
    return {
      primary: [
        { term_name: '小学一年级（2020级）', class_total: 0 },
        { term_name: '小学二年级（2019级）', class_total: 0 },
        { term_name: '小学三年级（2018级）', class_total: 0 },
        { term_name: '小学四年级（2017级）', class_total: 0 },
        { term_name: '小学五年级（2016级）', class_total: 0 },
        { term_name: '小学六年级（2015级）', class_total: 0 }
      ],
      middle: [
        { term_name: '初中一年级（2020级）', class_total: 0 },
        { term_name: '初中二年级（2019级）', class_total: 0 },
        { term_name: '初中三年级（2018级）', class_total: 0 }
      ],
      high: [
        { term_name: '高中一年级（2020级）', class_total: 0 },
        { term_name: '高中二年级（2019级）', class_total: 0 },
        { term_name: '高中三年级（2018级）', class_total: 0 }
      ],
      secondary: [
        { term_name: '中专一年级（2020级）', class_total: 0 },
        { term_name: '中专二年级（2019级）', class_total: 0 },
        { term_name: '中专三年级（2018级）', class_total: 0 }
      ]
    }
  },

  computed: {
    showList() {
      let list = []

      if (this.type === '小学') {
        list = ['primary']
      } else if (this.type === '初中') {
        list = ['middle']
      } else if (this.type === '高中') {
        list = ['high']
      } else if (this.type === '小学+初中') {
        list = ['primary', 'middle']
      } else if (this.type === '初中+高中') {
        list = ['middle', 'high']
      } else if (this.type === '小学+初中+高中') {
        list = ['primary', 'middle', 'high']
      } else if (this.type === '中专') {
        list = ['secondary']
      }

      return list
    }
  },

  methods: {
    handleBlur(count, list, idx) {
      count = parseInt(count) || 0
      if (count < 0) count = 0

      let name = list[idx].term_name
      let newItem = { term_name: name, class_total: count }
      this.$set(list, idx, newItem)
    },

    isShow(flag) {
      return this.showList.includes(flag)
    },

    getLevelData() {
      let levelData = {}

      for (let idx in this.showList) {
        let item = this.showList[idx]
        levelData[item] = this[item]
      }

      levelData = JSON.parse(JSON.stringify(levelData))

      return levelData
    }
  },

  mounted() {}
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.trial-framework {
  .level {
    position: relative;
    padding-left: 90px;
    line-height: 32px;

    & + .level {
      margin-top: 20px;
    }

    .level-branch {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 32px;
    }

    .level-grade {
      position: relative;
      padding-bottom: 20px;
      display: flex;
      justify-content: space-between;
      font-weight: 500;

      @media screen and (max-width: $mobile-max-width) {
        flex-flow: column;
        justify-content: flex-start;
      }

      &:before {
        position: absolute;
        left: -22px;
        top: 15px;
        content: '';
        width: 13px;
        height: 1px;
        background-color: #979797;
      }
      &:after {
        position: absolute;
        left: -22px;
        top: 0;
        bottom: 0;
        content: '';
        width: 1px;
        background-color: #979797;
      }
      &:first-of-type {
        &:before {
          left: -35px;
          width: 26px;
        }
        &:after {
          top: 15px;
        }
      }
      &:last-of-type {
        &:after {
          bottom: auto;
          height: 16px;
        }
      }

      &:last-child {
        padding-bottom: 0;
      }

      b {
        margin-left: 10px;
        margin-right: 20px;
        font-weight: 400;
        color: #999;
      }

      .count {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-weight: 400;
        .el-input {
          display: inline-block;
          width: 60px;
          margin: 0 10px;
        }
      }
    }
  }

  .frame-tip {
    margin-top: 20px;
    color: #999;
    font-size: 12px;
  }
}
</style>
